import React, { useState } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "typeface-poppins";
import "./App.css";
import AuthContent from "./AuthContent";
import { AuthProvider } from "./AuthContext";
import { TenantProvider } from "./contexts/TenantContext";
import { TokenExpirationProvider } from "./contexts/TokenExpirationContext";
import LoginForm from "./Forms/Login/Login";
import "./styles/buttons.css";
import "./styles/global.css";
import "./styles/loading.css";
import "./styles/pagination.css";

const globalStyles = {
  fontFamily: "Poppins, sans-serif",
  backgroundColor: "#F0F0F0",
  // Otros estilos globales si es necesario
};

function App() {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <TenantProvider>
      <AuthProvider>
        <TokenExpirationProvider>
          <Router>
            <div className="App" style={{ ...globalStyles }}>
              <Routes>
                <Route path="/login" element={<LoginForm />} />
                <Route
                  path="/*"
                  element={
                    <AuthContent
                      globalStyles={globalStyles}
                      isCollapsed={isCollapsed}
                      toggleSidebar={toggleSidebar}
                    />
                  }
                />
              </Routes>
            </div>
          </Router>
        </TokenExpirationProvider>
      </AuthProvider>
    </TenantProvider>
  );
}

export default App;
